import { isBefore } from "date-fns/isBefore";
import { subDays } from "date-fns/subDays";

export const isNewVideo = (date: Date) => {
  return isBefore(subDays(new Date(), 10), date);
};
